// extracted by mini-css-extract-plugin
export default {"container":"jO-z","dimension":"kO-z","dimensionLabels":"lO-z"};